import axios from "axios";
import { API } from "../../backend";
import multipart from "../user/mutlipart";
import authHeader from "../auth-header";

const excelfileDocument = (formData) => {
    console.log('formData', formData)
    return axios.post(API + "helper/upload-document/", 
        formData
    ,
    {headers: multipart() });
  }

  const viewListuploadFilter = (tags) =>{
    return axios.get(API + `helper/documents/?tags=${tags}`,{headers: authHeader()} ) 
  }
  
  const viewListuploadFilterview = (reference_name, reference_id) => {
    return axios.get(
      API + `helper/Documentsfilter-view/?reference_name=${reference_name}&reference_id=${reference_id}`,
      { headers: authHeader() }
    );
  }

  const viewListupload = (tags) =>{
    return axios.get(API + 'helper/documents/',{headers: authHeader()} ) 
  }
  const DocumentUpload = {
    excelfileDocument,
    viewListuploadFilter,
    viewListuploadFilterview,
    viewListupload
  };
  export default DocumentUpload;